// extracted by mini-css-extract-plugin
export default {"oosNotify":"G5-z","count":"H5-z","otherColors":"I5-z","modalContent":"J5-z","body":"K5-z"};